import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { environment } from "../../environments/environment";
import { ArticleService } from "../service/article.service";
import { LazyImgDirective } from "../lazy-img.directive";
import { ImgFallbackDirective } from "../shared/img-fallback.directive";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-new-screen-five",
  templateUrl: "./new-screen-five.component.html",
  styleUrls: ["./new-screen-five.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LazyImgDirective, ImgFallbackDirective, MatButton]
})
export class NewScreenFiveComponent implements OnInit {
  podcasts: object[] = [];
  private curated = false;

  constructor(
    private service: ArticleService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.get_podcast();
    this.applyCuration();
  }

  get_podcast() {
    this.service
      .get_article({ main_category: "podcast", limit: 10 })
      .subscribe(data => {
        // Editor curation wins the race: if the overlay already set podcasts,
        // don't overwrite with the auto list (either resolve-order → curated wins).
        if (this.curated) { this.cdr.markForCheck(); return; }
        if (data["success"]) {
          this.podcasts = data["data"];
        }
        this.cdr.markForCheck();
      });
  }

  // Editor-curation overlay (SSR-safe: override-with-guard, no reset-then-fill).
  // On empty/error the auto list stays → zero regression.
  applyCuration() {
    this.service.getPageLayoutCached("homepage").subscribe(
      (res: any) => {
        const sections = (res && res.data && res.data.sections) || [];
        const sec = sections.find((s: any) => s && s.key === "podcast");
        if (sec && Array.isArray(sec.articles) && sec.articles.length) {
          this.podcasts = sec.articles;
          this.curated = true;
        }
        this.cdr.markForCheck();
      },
      () => {}
    );
  }

  buildHrefLink(story) {
    let href_link = environment.frontend_url;
    switch (story["main_category"]) {
      case "insights":
        href_link += `insights/${story["category"]}/${story["blog_category"]}/`;
        break;
      case "podcast":
        href_link += `podcast/${story["event"]}/`;
        break;
      default:
        href_link += `tv/${story["event"]}/${story["category"]}/`;
    }
    return href_link + story["slug"];
  }
}
